import React from 'react';
import Header from '../components/Header/Header';
import Navbar from '../components/Navbar/Navbar';
import Slideshow from '../components/Slideshow/Slideshow';
import WelcomeCitySection from '../components/WelcomeCitySection/WelcomeCitySection';
import PlacesToVisit from '../components/PlacesToVisit/PlacesToVisit';
import NearbyPlacesToVisit from '../components/NearbyPlacesToVisit/NearbyPlacesToVisit';

const AboutCityPage = () => {
  return (
    <div>
        <Header />
        <Navbar />
        <Slideshow />
        <WelcomeCitySection />
        
        <div className="border-t-2 border-green-500 my-8 w-4/5 mx-auto"></div>

        <PlacesToVisit />
        <div className="border-t-2 border-green-500 my-8 w-4/5 mx-auto"></div>
        <NearbyPlacesToVisit />
    </div>
  );
};

export default AboutCityPage;
